import { render, staticRenderFns } from "./x-expand-container.vue?vue&type=template&id=61f02aac&scoped=true&"
import script from "./x-expand-container.vue?vue&type=script&lang=js&"
export * from "./x-expand-container.vue?vue&type=script&lang=js&"
import style0 from "./x-expand-container.vue?vue&type=style&index=0&id=61f02aac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f02aac",
  null
  
)

export default component.exports